/* eslint-disable no-undef */
export const apiConfig = {
  backendUrl: process.env.REACT_APP_BASEAPI_URL,
};
